import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { LoginPostRequestModel, LoginPostResponseModel } from "@/features/auth/services/login-model";

export class LoginApi {
  /**
   * ログイン
   */
  public postLogin = async (
    param: LoginPostRequestModel
  ): Promise<LoginPostResponseModel> => {
    const path = `/api/login`;
    const res = await ApiClient.instance.post<LoginPostResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
